// extracted by mini-css-extract-plugin
var _1 = "ReportFeedStyle-module__form___LYiHI";
var _2 = "ReportFeedStyle-module__headline___ewEJ9";
var _3 = "ReportFeedStyle-module__icon___V9QIG";
var _4 = "ReportFeedStyle-module__message___JQeLL";
var _5 = "ReportFeedStyle-module__report___lQA6l";
var _6 = "ReportFeedStyle-module__submit___MZj6t";
var _7 = "ReportFeedStyle-module__success___g_qw1";
export { _1 as "form", _2 as "headline", _3 as "icon", _4 as "message", _5 as "report", _6 as "submit", _7 as "success" }
